<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-100">
      <div class="bg-white p-8 rounded shadow-md w-full max-w-sm">
          <h2 class="text-2xl font-semibold mb-6 text-gray-800 text-center">Login with Magic Link</h2>
          <div class="mb-4">
              <input
                  type="email"
                  placeholder="Email"
                  v-model="email"
                  class="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
          </div>
          <button
              @click="sendMagicLink"
              class="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
              Send magic link
          </button>
          <div class="mt-4 text-center">
              <p>
                  <a href="/login" class="text-blue-500 hover:underline">Login with password</a>
              </p>
          </div>
           <p v-if="errorMessage" class="mt-4 text-green-500 text-center">{{ errorMessage }}</p>
      </div>
  </div>
</template>

<script>
import AuthService from '@/services/auth.service';

export default {
  data() {
      return {
          email: '',
          errorMessage: null,
      };
  },
  methods: {
      async sendMagicLink() {
          try {
              await AuthService.sendMagicLink(this.email);
              window.localStorage.setItem('emailForSignIn', this.email);
              this.errorMessage = 'Magic link has been sent to your email';
          } catch (error) {
              this.errorMessage = error.message;
          }
      },
  },
};
</script>